// 261005 E1-P1 — cuộn tới một phần tử có thể CHƯA tồn tại (chặng vừa mount, bảng đang tải…).
// requestAnimationFrame dò từng khung hình, giới hạn 3s; KHÔNG dùng setTimeout mù để "đoán" lúc render xong.
export const FLASH_CLASS = 'wb-flash';
export const FLASH_MS = 2500;

export interface ScrollOpts { block?: ScrollLogicalPosition; flash?: boolean; timeoutMs?: number }

/** Trả hàm huỷ. `done(found)` gọi đúng một lần (found=false khi hết 3s mà phần tử không xuất hiện). */
export const scrollWhenReady = (id: string, done?: (found: boolean) => void, opts: ScrollOpts = {}): (() => void) => {
  const { block = 'center', flash = true, timeoutMs = 3000 } = opts;
  let finished = false;
  let raf = 0;
  const started = Date.now();

  const stop = () => {
    finished = true;
    if (raf) cancelAnimationFrame(raf);
  };
  const tryOnce = (): boolean => {
    const el = document.getElementById(id);
    if (!el) return false;
    el.scrollIntoView({ behavior: 'smooth', block });
    if (flash) {
      el.classList.remove(FLASH_CLASS);
      // buộc reflow để animation chạy lại khi nhấp nháy liên tiếp cùng phần tử
      void el.offsetWidth;
      el.classList.add(FLASH_CLASS);
      window.setTimeout(() => el.classList.remove(FLASH_CLASS), FLASH_MS);
    }
    return true;
  };
  const check = () => {
    if (finished) return;
    if (tryOnce()) { stop(); done?.(true); return; }
    if (Date.now() - started > timeoutMs) { stop(); done?.(false); return; }
    raf = requestAnimationFrame(check);
  };

  check();
  return () => { if (!finished) stop(); };
};
